<template >
  <div id="app" >
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}

</script>

<style >
html{
  margin:0 !important; 
  padding:0 !important;
}

body{
  margin:0 !important;
  padding:0 !important;
}
</style>
